import { render, staticRenderFns } from "./ImportFromKomchatAI.vue?vue&type=template&id=495f9a23&scoped=true&"
import script from "./ImportFromKomchatAI.vue?vue&type=script&lang=js&"
export * from "./ImportFromKomchatAI.vue?vue&type=script&lang=js&"
import style0 from "./ImportFromKomchatAI.vue?vue&type=style&index=0&id=495f9a23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495f9a23",
  null
  
)

export default component.exports